(function ($, Drupal, once) {
  'use strict';

  let pageIsDesktop = true;
  let scrollPosition = 0;

  Drupal.behaviors.regionHeader = {
    attach: function (context, settings) {
      const {addHeaderClickHandlers, addResizeListeners, processMenuItems, setMenuNavigationVisible} = Drupal.behaviors.regionHeader;

      if ($('body').width() < 1025) {
        $('.nav-menu.menu-level-0').addClass('mobile');

        pageIsDesktop = false;
      }

      addHeaderClickHandlers();
      addResizeListeners();
      processMenuItems();
      setMenuNavigationVisible();
    },
    addHeaderClickHandlers: function () {
      const {openMobileMenu, closeMobileMenu} = Drupal.behaviors.regionHeader;

      const $navs = $('header nav');
      const $search = $('.search');
      const $searchInput = $('[name="search_api_fulltext"]');

      $(once('mobileOpenMenuClickHandler', '.mobile-hamburger')).click(openMobileMenu);
      $(once('mobileCloseMenuClickHandler', '.close-menu')).click(closeMobileMenu);

      // Clicking search icon opens search, closes main nav.
      $('.open-search').click(function () {
        $navs.hide();
        $search.show();
        $searchInput.focus();
      });

      // Clicking the close button closes search, opens main nav.
      $('.close-search').click(function () {
        $navs.show();
        $search.hide();
        $searchInput.val('').blur();
      });

      $('svg.submit-button-icon').on('click', function () {
        $(this).parent('.submit-button').find('input').trigger('click');
      });
    },
    addResizeListeners: function () {
      const {showPageContent, hidePageContent, relocateMegaMenu, updateMenuItemMaxWidth, closeMobileMegaMenu, toggleMegaMenu, updateDropdownItemsPaddingLeft} = Drupal.behaviors.regionHeader;

      const onWindowResizeEvent = () => {
        const $navMenu = $('.nav-menu');
        const $expandedMegaMenu = $('.mega-menu--expanded.menu-item--expanded');
        const $firstLevelNav = $('.nav-menu.menu-level-0');
        const mobileMenuIsActive = !$('.main-navigation-wrapper.in-active').length;

        let relocateMegaMenus = false;

        if ($firstLevelNav.hasClass('mobile') && $('body').width() >= 1025) {
          $firstLevelNav.removeClass('mobile');
          pageIsDesktop = true;
          relocateMegaMenus = true;

          if (mobileMenuIsActive) {
            showPageContent();
            $('body').scrollTop(scrollPosition);
          }
        }
        else if (!$firstLevelNav.hasClass('mobile') && $('body').width() < 1025) {
          $firstLevelNav.addClass('mobile');
          pageIsDesktop = false;
          relocateMegaMenus = true;

          if (mobileMenuIsActive) {
            hidePageContent();
          }
        }

        if (relocateMegaMenus) {
          $('ul.menu > li').each(function () {
            const $menuItem = $(this);
            const $megaMenu = $(`[data-entity-id="${$menuItem.attr('mega-menu-id')}"]`);

            relocateMegaMenu($megaMenu);
            updateMenuItemMaxWidth($menuItem);
          });

          if ($expandedMegaMenu.length) {
            const $expandedMenuItem = $('li.menu-item--expanded');

            if (pageIsDesktop) {
              closeMobileMegaMenu($expandedMenuItem, $expandedMegaMenu, $navMenu);
            }
            else {
              toggleMegaMenu($expandedMenuItem, $expandedMegaMenu, false);
            }
          }
        }
      };

      // Per design, the dropdown menu item text is centered and its child items' text are aligned to its left.
      // This kind of behavior is not easily achievable with pure CSS, so this code will watch the dropdown menu item
      // text for text or button size changes, then update the left padding for the dropdown items accordingly
      const $dropdown = $('.nav-menu .dropdown');
      if ($dropdown.length) {
        const dropdownButtonResizeObserver = new ResizeObserver(() => {
          updateDropdownItemsPaddingLeft($dropdown);
        });

        // Watch for dropdown width changes
        dropdownButtonResizeObserver.observe($dropdown[0]);

        // Watch for dropdown text size change
        dropdownButtonResizeObserver.observe($dropdown.find('span')[0]);
      }

      if (window.addEventListener) {
        window.addEventListener('resize', onWindowResizeEvent, true);
      }
      else if (window.attachEvent) {
        window.attachEvent('onresize', onWindowResizeEvent);
      }
    },
    processMenuItems: function () {
      const {relocateMegaMenu, updateMenuItemMaxWidth, addMenuItemEventHandlers} = Drupal.behaviors.regionHeader;

      // Process all menu items.
      $(once('processMenuItems', 'ul.menu > li')).each(function () {
        const $menuItem = $(this);
        const $megaMenu = $(`[data-entity-id="${$menuItem.attr('mega-menu-id')}"]`);
        const $navMenu = $('.nav-menu');

        // Move mega menu to the header region.
        relocateMegaMenu($megaMenu);
        updateMenuItemMaxWidth($menuItem);

        // If there is a mega menu associated with this menu item, add mouse handlers.
        if ($megaMenu.length) {
          // Add event handlers
          addMenuItemEventHandlers($menuItem, $megaMenu, $navMenu);
        }
        // No mega menu is associated with this item
        else {
          const spanElement = $menuItem.find('.nav-item-content');
          const anchorElement = $menuItem.find('a');

          // Hide the <span> and unhide the <a> tag
          anchorElement.removeClass(['hidden', 'xl:inline-block']);
          anchorElement.addClass('inline-block');
          spanElement.addClass('hidden');
        }
      });
    },
    openMobileMenu: function () {
      const {hidePageContent} = Drupal.behaviors.regionHeader;

      const $mainNavWrapper = $('.main-navigation-wrapper');
      const $mobileHeader = $('.mobile-header');
      const $storyTeller = $('.node--type-storyteller');

      scrollPosition = $('body').scrollTop();

      $mainNavWrapper.removeClass('in-active');
      $mobileHeader.hide();

      hidePageContent();

      $('body').scrollTop(0);

      if ($storyTeller.length) {
        const $mainNav = $('body header.region-header div.main-navigation-wrapper nav');
        const $alert = $('.sitewide-alert');

        let alertHeight = $alert.length ? $alert.outerHeight() : 0;

        $mainNav.css('max-height', `calc(100vh - ${alertHeight}px)`);
        $mainNav.css('overflow-y', 'auto');
        $mainNav.scrollTop($mainNav.clientHeight - $mainNav.scrollHeight);

        // Watch for $alert message to load then reset header nav height.
        let resizeObserver = new ResizeObserver(() => {
          alertHeight = $alert.length ? $alert.outerHeight() : 0;
          $mainNav.css('max-height', `calc(100vh - ${alertHeight}px)`);
        });

        resizeObserver.observe($alert);
      }
    },
    closeMobileMenu: function () {
      const {showPageContent} = Drupal.behaviors.regionHeader;

      const $mainNavWrapper = $('.main-navigation-wrapper');
      const $mobileHeader = $('.mobile-header');

      $mainNavWrapper.addClass('in-active');

      $mobileHeader.show();

      showPageContent();

      $('body').scrollTop(scrollPosition);

      $('.mega-menu--expanded').removeClass(['mega-menu--expanded', 'menu-item--expanded']);
      $('.nav-menu').css('display', '');

      // Moves nav item content into other-sections div
      $('.menu_link_content').detach().appendTo('.other-sections .other-sections-list-items');
      $('.other-sections').css({display: ''});
    },
    openMobileMegaMenu: function ($megaMenu, $menuItem = null, $navMenu) {
      $navMenu.css('display', 'none'); // Hide main menu
      $megaMenu.addClass(['mega-menu--expanded', 'menu-item--expanded']); // Show the mega menu

      if ($menuItem) {
        $menuItem.addClass('menu-item--expanded');
      }
      // Moves nav item content out of other-sections div
      $('.menu_link_content').detach().insertAfter('.other-sections');
      $('.other-sections').css({display: 'none'});

      // Unhide the Mega Menu
      $megaMenu.find('.mega-menu').css({display: ''});
    },
    closeMobileMegaMenu: function ($menuItem = null, $megaMenu, $navMenu) {
      $navMenu.css('display', ''); // Show main menu
      $megaMenu.removeClass(['mega-menu--expanded', 'menu-item--expanded']); // Hide the mega menu

      // Moves nav item content into other-sections div
      $('.menu_link_content').detach().appendTo('.other-sections .other-sections-list-items');
      $('.other-sections').css({display: ''});

      if ($menuItem) {
        $menuItem.removeClass('menu-item--expanded');
      }
    },
    toggleMegaMenu: function ($menuItem, $megaMenu, $expand) {
      let $menu = $menuItem.parent('.menu');
      let $regionHeader = $menu.parents('.region-header');

      // Either expand or collapse relevant elements.
      $menuItem.attr('aria-expanded', $expand);
      $menuItem.toggleClass('menu-item--expanded', $expand);
      $megaMenu.toggleClass('menu-item--expanded', $expand);
      $megaMenu.toggleClass('mega-menu--expanded', $expand);
      $menu.toggleClass('menu--menu-item-expanded', $expand);
      $regionHeader.toggleClass('region--menu-item-expanded', $expand);
    },
    relocateMegaMenu: function ($megaMenu) {
      if ($megaMenu.length) {
        let $detachedMegaMenu = $megaMenu.detach();

        // Move mega menu to the header region.
        if (pageIsDesktop) {
          const $header = $('.page').children('header').first();
          $header.append($detachedMegaMenu);
        }
        else {
          $('.nav-menu.menu-level-0').parent().prepend($detachedMegaMenu);
          $('button.nav-dropdown svg').removeClass('-rotate-90');
          $('button.nav-dropdown svg').addClass('rotate-90');
          $('button.nav-dropdown').next('ul').addClass('hidden');
          $('button.nav-dropdown').addClass('mega-menu__dropdown-button');
        }
      }
    },
    addMenuItemEventHandlers: function ($menuItem, $megaMenu, $navMenu) {
      const {toggleMegaMenu, openMobileMegaMenu, closeMobileMegaMenu} = Drupal.behaviors.regionHeader;

      let contextMenu = false;

      $megaMenu.contextmenu(function () {
        // Context menus on Firefox fire a mouseleave event.
        // Flag that a context menu is about to display.
        contextMenu = true;
      });

      $menuItem.mouseenter(function () {
        if (pageIsDesktop) {
          // Unhide the Mega Menu
          $megaMenu.find('.mega-menu').css({display: ''});
          toggleMegaMenu($menuItem, $megaMenu, true);
        }
      });

      $menuItem.mouseleave(function (event) {
        if (pageIsDesktop) {
          if (contextMenu) {
            contextMenu = false;
            event.preventDefault();
          }
          else {
            toggleMegaMenu($menuItem, $megaMenu, false);
          }
        }
      });

      $menuItem.click(function () {
        if (!pageIsDesktop) {
          // Verify that mega menu exists before opening it.
          if ($megaMenu.find('.mega-menu--full').length) {
            openMobileMegaMenu($megaMenu, $menuItem, $navMenu);
          }
        }
      });

      $megaMenu.mouseenter(function () {
        if (pageIsDesktop) {
          // Unhide the Mega Menu
          $megaMenu.find('.mega-menu').css({display: ''});
          toggleMegaMenu($menuItem, $megaMenu, true);
        }
      });

      $megaMenu.mouseleave(function (e) {
        if (pageIsDesktop) {
          // Ignore event if a context menu is about to display.
          if (contextMenu) {
            contextMenu = false;
            e.preventDefault();
          }
          else {
            toggleMegaMenu($menuItem, $megaMenu, false);
          }
        }
      });

      // Set event listener on the back button
      $megaMenu.find('.mega-nav-item').first().click(() => {
        closeMobileMegaMenu($menuItem, $megaMenu, $navMenu);
      });
    },
    updateMenuItemMaxWidth: function ($menuItem) {
      let menuItemContentWidth = 0;
      if ($menuItem.hasClass('dropdown')) {
        menuItemContentWidth = $menuItem.find('span').width() + $menuItem.find('svg').width();
      }
      else {
        menuItemContentWidth = $menuItem.find('a').width();
      }

      $menuItem.css('--dropdown-item-max-width', `${menuItemContentWidth + 50}px`);
    },
    updateAllMenuItemsMaxWidth: function () {
      const {updateMenuItemMaxWidth} = Drupal.behaviors.regionHeader;

      $('ul.menu > li').each(function (_, menuItem) {
        updateMenuItemMaxWidth($(menuItem));
      });
    },
    setMenuNavigationVisible: function () {
      $('.block-menu.navigation').each(function () {
        if ($(this).css('visibility') === 'hidden') {
          $(this).css({visibility: 'visible'});
        }
      });
    },
    hidePageContent: function () {
      const $headerRegion = $('.region-header');
      const $contentRegion = $('.region-content, .blog-landing-page, .blog-post-page, .blog-categories-page, .blog-archive-page');
      const $footerRegion = $('.region-footer');

      $headerRegion.css('height', '100vh');
      $contentRegion.css('display', 'none');
      $footerRegion.css('display', 'none');
    },
    showPageContent: function () {
      const $headerRegion = $('.region-header');
      const $contentRegion = $('.region-content, .blog-landing-page, .blog-post-page, .blog-categories-page, .blog-archive-page');
      const $footerRegion = $('.region-footer');

      $headerRegion.css('height', 'auto');
      $contentRegion.css('display', '');
      $footerRegion.css('display', '');
    },
    updateDropdownItemsPaddingLeft: function ($dropdownButton) {
      const dropdownButtonOffset = $dropdownButton.offset().left;
      const dropdownButtonContentOffset = $dropdownButton.find('span').offset().left;

      // This calculation returns the amount of space between the centered dropdown button
      // text and the left side of the button
      const dropdownItemsPadding = dropdownButtonContentOffset - dropdownButtonOffset;

      $dropdownButton.css('--dropdown-item-padding-left', `${dropdownItemsPadding}px`);
    }
  };

  // Execute immediately to reduce resizing flicker
  Drupal.behaviors.regionHeader.updateAllMenuItemsMaxWidth();
  Drupal.behaviors.regionHeader.setMenuNavigationVisible();
})(jQuery, Drupal, once);
